export default {
  setEmployees(state, payload) {
    state.employees = payload
  }
}
